<template>
  <div>
    <v-container
      v-if="logs !== null && !isFermi"
      fluid
      class="mt-12"
      style="background-color: whitesmoke"
    >
      <v-text-field
        outlined
        v-model="normalizer"
        label="normalizer"
      ></v-text-field>
      <div>
        <v-row class="row--dense mt-5">
          <v-col
            v-for="(day, index) in getTimeLineNotFermi()"
            v-bind:key="index"
          >
            <v-btn
              v-if="day === year"
              color="green"
              class="w-100 h-100 p-2"
              tile
              @click="fetchData(day)"
              >{{ day }}<br />
              This Month
            </v-btn>
            <v-btn
              v-else
              color="green"
              class="w-100 h-100 p-2"
              tile
              @click="fetchData(day)"
              >{{ day }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              color="green"
              class="w-100 h-100 p-2"
              tile
              @click="fetchData('ALL')"
              >All Time</v-btn
            >
          </v-col>
          <v-col>
            <v-btn
              color="green"
              class="w-100 h-100 p-2"
              tile
              @click="fetchData('PREVIOUS')"
              >Previous Months</v-btn
            ></v-col
          >
        </v-row>
        <br />
        <v-card class="px-5 py-5 my-5">
          <v-card-title>Report of {{ displayText }}</v-card-title>
          <table style="border: 1px solid black">
            <tr style="border: 1px solid black">
              <th style="border: 1px solid black; font-size: 12px">Project</th>
              <th
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                {{ member.full_name }}
              </th>
              <th style="border: 1px solid black; font-size: 12px">Total</th>
            </tr>
            <tr style="border: 1px solid black; font-size: 12px">
              <td style="border: 1px solid black; font-size: 12px">
                {{ logs.project }}
              </td>
              <td
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                <div v-if="reportUserLog()[member.id] !== undefined">
                  {{ round(reportUserLog()[member.id].log_hour) }}
                </div>
              </td>
              <td>{{ round(grandTotalMonthTotalNotFermi()) }}</td>
            </tr>
            <tr style="border: 1px solid black; font-size: 12px">
              <td>Month Total normalized</td>
              <td
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                {{ normalizeHours(round(grandTotalMonthNotFermi(member.id))) }}
              </td>
              <td>
                {{ normalizeHours(round(grandTotalMonthTotalNotFermi())) }}
              </td>
            </tr>
            <tr style="border: 1px solid black; font-size: 12px">
              <td style="border: 1px solid black; font-size: 12px">Salary</td>
              <td
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                <div v-if="cost[member.id] !== undefined">
                  <v-text-field v-model="cost[member.id]"></v-text-field>
                </div>
              </td>
            </tr>
            <tr style="border: 1px solid black; font-size: 12px">
              <td style="border: 1px solid black; font-size: 12px">
                Grand Total
              </td>
              <td
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                <div v-if="cost[member.id] !== undefined">
                  {{
                    round(
                      normalizeHours(
                        cost[member.id] *
                          salary *
                          parseFloat(grandTotalMonthNotFermi(member.id))
                      )
                    )
                  }}
                </div>
              </td>
              <td>{{ round(normalizeHours(getGrandTotalOfAllNotFermi())) }}</td>
            </tr>
          </table>
        </v-card>
      </div>
    </v-container>
    <v-container v-else class="mt-12" style="background-color: whitesmoke">
      <div>
        <v-row class="row--dense mt-5">
          <v-col v-for="(day, index) in getTimeline()" v-bind:key="index">
            <v-btn
              v-if="day === year"
              color="green"
              class="w-100 h-100 p-2"
              tile
              @click="fetchData(day)"
              >{{ day }}<br />
              This Month
            </v-btn>
            <v-btn
              v-else
              color="green"
              class="w-100 h-100 p-2"
              tile
              @click="fetchData(day)"
              >{{ day }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              color="green"
              class="w-100 h-100 p-2"
              tile
              @click="fetchData('ALL')"
              >All Time</v-btn
            >
          </v-col>
          <v-col>
            <v-btn
              color="green"
              class="w-100 h-100 p-2"
              tile
              @click="fetchData('PREVIOUS')"
              >Previous Months</v-btn
            ></v-col
          >
        </v-row>
        <br />
        <v-card class="px-5 py-5 my-5">
          <v-card-title style="align-text: center">{{
            displayText
          }}</v-card-title>
          <table style="border: 1px solid black">
            <tr style="border: 1px solid black">
              <th style="border: 1px solid black; font-size: 12px">Project</th>
              <th
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                {{ member.full_name }}
              </th>
              <th style="border: 1px solid black; font-size: 12px">Total</th>
              <th style="border: 1px solid black; font-size: 12px">Total%</th>
            </tr>
            <tr
              style="border: 1px solid black; font-size: 12px"
              v-for="item in logs"
              :key="item.project_id"
            >
              <td style="border: 1px solid black; font-size: 12px">
                {{ item.project }}
              </td>
              <td
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                <div v-if="item.user_log[member.id] !== undefined">
                  {{ item.user_log[member.id].log_hour }}
                </div>
              </td>
              <td style="border: 1px solid black; font-size: 12px">
                {{ grandTotalForRow(item.user_log) }}
              </td>
              <td style="border: 1px solid black; font-size: 12px">
                {{
                  getPercentage(
                    grandTotalForRow(item.user_log),
                    grandTotalOfTime()
                  )
                }}%
              </td>
            </tr>
            <tr style="border: 1px solid black; font-size: 12px">
              <td>Month Total</td>
              <td
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                {{ grandTotalMonth(member.id) }}
              </td>
              <td style="border: 1px solid black; font-size: 12px"></td>
            </tr>
            <tr style="border: 1px solid black; font-size: 12px">
              <td>Month Total</td>
              <td
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                {{
                  getPercentage(grandTotalMonth(member.id), grandTotalOfTime())
                }}%
              </td>
              <td style="border: 1px solid black; font-size: 12px"></td>
              <td style="border: 1px solid black; font-size: 12px">
                {{ getPercentage(grandTotalOfTime(), grandTotalOfTime()) }}%
              </td>
            </tr>
            <tr style="border: 1px solid black; font-size: 12px">
              <td style="border: 1px solid black; font-size: 12px">Salary</td>
              <td
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                <div v-if="cost[member.id] !== undefined">
                  <v-text-field v-model="cost[member.id]"></v-text-field>
                </div>
              </td>
            </tr>
            <tr style="border: 1px solid black; font-size: 12px">
              <td style="border: 1px solid black; font-size: 12px">
                Grand Total
              </td>
              <td
                style="border: 1px solid black; font-size: 12px"
                v-for="member in getUserList"
                :key="member.id"
              >
                <div v-if="cost[member.id] !== undefined">
                  {{
                    cost[member.id] *
                    salary *
                    parseFloat(grandTotalMonth(member.id))
                  }}
                </div>
              </td>
              <td>{{ getGrandTotalOfAll() }}</td>
            </tr>
          </table>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
// [TODO: REFACTOR THIS Script]

import axios from "axios";
import {mapActions, mapGetters} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
import {
  customFormatDate,
  GetEndOfMonthDate,
  GetStartOfMonthDate,
  today,
} from "@/Utilites/timerHelper";
export default {
  name: "Report",
  data() {
    return {
      cost: {
        3: 6,
        13: 6,
        5: 5.5,
        2: 5.5,
        20: 5.5,
        12: 4.0,
        8: 4.0,
        10: 3.0,
        9: 5.5,
        29: 6,
        26: 4,
        25: 4,
        24: 6,
      },
      precision: 1,
      salary: 100000,
      displayText: customFormatDate(today(), "YYYY-M"),
      totalLogs: null,
      menu: false,
      normalizer: 100,
      val: 0,
      year: customFormatDate(today(), "YYYY-M"),
      all: false,
      logs: null,
      isFermi: true,
      toggle: false,
      headers: [
        {text: "Member", value: "user_name"},
        {text: "Hour (hr)", value: "total_hours"},
      ],
    };
  },
  watch: {
    getReportNew(oldData, newData) {
      if (oldData !== newData) {
        this.fetchData();
      }
    },
  },
  computed: {
    ...mapGetters(["getTeamNameList"]),
    getUserList() {
      const userLog = this.reportUserLog();
      if (!userLog) return [];
      const teamById = {};
      (this.getTeamNameList || []).forEach((member) => {
        teamById[member.id] = member;
        teamById[String(member.id)] = member;
      });
      return Object.keys(userLog)
        .map((rawId) => {
          const id = parseInt(rawId, 10);
          const fromTeam = teamById[id] || teamById[rawId];
          if (fromTeam) return fromTeam;
          return {id, full_name: `User ${rawId}`};
        })
        .sort((a, b) =>
          String(a.full_name || "").localeCompare(String(b.full_name || ""))
        );
    },
  },
  mounted() {
    this.ensureReportTeamList();
    this.fetchData(this.year);
  },
  methods: {
    ...mapActions([
      "fetchTeamNameList",
      "showLoadingProcess",
      "closeLoading",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async ensureReportTeamList() {
      if ((this.getTeamNameList || []).length) return;
      try {
        await this.fetchTeamNameList();
      } catch {
        /* report still renders user ids without names */
      }
    },
    reportUserLog() {
      if (this.logs == null) return null;
      if (Array.isArray(this.logs)) {
        const merged = {};
        this.logs.forEach((item) => {
          const block = item && item.user_log;
          if (!block || typeof block !== "object") return;
          Object.keys(block).forEach((userId) => {
            const hours = parseFloat(block[userId].log_hour) || 0;
            if (merged[userId]) {
              merged[userId].log_hour += hours;
            } else {
              merged[userId] = {log_hour: hours};
            }
          });
        });
        return merged;
      }
      return this.logs.user_log || null;
    },
    reportTimelineMonths() {
      if (this.logs == null) return [];
      let timeline = [];
      if (Array.isArray(this.logs)) {
        this.logs.forEach((item) => {
          const data = item && item.project_timeline;
          if (!data) return;
          if (Array.isArray(data)) timeline.push(...data);
          else if (typeof data === "object")
            timeline.push(...Object.values(data));
        });
      } else {
        const data = this.logs.project_timeline;
        if (Array.isArray(data)) timeline.push(...data);
        else if (data && typeof data === "object")
          timeline.push(...Object.values(data));
      }
      return [...new Set(timeline)].sort();
    },
    grandTotalMonthNotFermi(id) {
      const filtered = this.reportUserLog();
      const row = filtered && (filtered[id] || filtered[String(id)]);
      if (row) {
        return parseFloat(row.log_hour).toFixed(this.precision);
      }
      return (0).toFixed(this.precision);
    },
    grandTotalForRow(value) {
      let sum = 0;
      for (let item in value) {
        sum = sum + parseFloat(value[item].log_hour);
      }
      return sum.toFixed(this.precision);
    },
    getPercentage(value, total) {
      return ((parseFloat(value) / parseFloat(total)) * 100).toFixed(1);
    },
    getGrandTotalOfAll() {
      let sum = 0;
      for (let member in this.getTeamNameList) {
        const id = this.getTeamNameList[member].id;
        if (this.cost[id] !== undefined) {
          sum =
            sum +
            this.cost[id] *
              this.normalizer *
              this.salary *
              parseFloat(this.grandTotalMonth(id));
        }
      }
      return this.round(sum);
    },
    getGrandTotalOfAllNotFermi() {
      let sum = 0;
      for (let member in this.getTeamNameList) {
        const id = this.getTeamNameList[member].id;
        if (this.cost[id] !== undefined) {
          sum =
            sum +
            this.cost[id] *
              this.salary *
              parseFloat(this.grandTotalMonthNotFermi(id));
        }
      }
      return sum.toFixed(this.precision);
    },
    grandTotalMonth(id) {
      let sum = 0;
      for (let items in this.logs) {
        const filtered = this.logs[items].user_log;

        if (filtered[id] !== undefined) {
          sum = sum + parseFloat(filtered[id].log_hour);
        }
      }
      return sum.toFixed(this.precision);
    },
    grandTotalMonthTotalNotFermi() {
      let sum = 0;
      for (let mem in this.getTeamNameList) {
        const id = this.getTeamNameList[mem].id;
        sum = sum + parseFloat(this.grandTotalMonthNotFermi(id));
      }
      return sum.toFixed(this.precision);
    },
    grandTotalMonthTotal() {
      let sum = 0;
      for (let mem in this.getTeamNameList) {
        const id = this.getTeamNameList[mem].id;
        sum = sum + parseFloat(this.grandTotalMonth(id));
      }
      return sum.toFixed(this.precision);
    },
    grandTotalOfTime() {
      let sum = 0;
      for (let items in this.logs) {
        const filtered = this.logs[items].user_log;
        for (let member in this.getTeamNameList) {
          let id = this.getTeamNameList[member].id;
          if (filtered[id] !== undefined) {
            sum = sum + parseFloat(filtered[id].log_hour);
          }
        }
      }
      return sum.toFixed(this.precision);
    },
    getTimeLineNotFermi() {
      return this.reportTimelineMonths();
    },
    getTimeline() {
      return this.reportTimelineMonths();
    },
    normalizeHours(value) {
      return (parseFloat(value) / this.normalizer).toPrecision(3);
    },
    showData(value) {
      if (value === "All") {
        this.all = true;
      } else {
        this.month = value;
        this.all = false;
      }
    },
    round(value) {
      if (value === undefined) return "";
      return Math.ceil(value);
    },
    async fetchData(month) {
      this.displayText = month;
      await this.showLoadingProcess();
      let fetchedId = this.$route.query.id;
      let fetchedName = this.$route.query.name;
      if (fetchedId === undefined && fetchedName === undefined) {
        fetchedId = this.$route.params.id;
        fetchedName = this.$route.params.name;
      }
      try {
        let startDate = "";
        let endDate = "";
        if (month === "ALL") {
          startDate = month;
          endDate = month;
        } else if (month === "PREVIOUS") {
          const timeline = this.reportTimelineMonths();
          if (timeline.length < 2) {
            throw new Error(
              "Need at least two months of data for Previous Months"
            );
          }
          startDate = GetStartOfMonthDate(timeline[0]);
          endDate = GetEndOfMonthDate(timeline[timeline.length - 2]);
        } else {
          startDate = GetStartOfMonthDate(month);
          endDate = GetEndOfMonthDate(month);
        }

        const response = await this.getReportNew(
          fetchedId,
          fetchedName,
          startDate,
          endDate
        );
        if (response.data.status === 400) {
          throw Error("Bad Request");
        }
        this.logs = response.data;
        await this.closeLoading();
        await this.showSnackBar({
          text: "Report Fetch Succeeded",
          color: "success",
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (e) {
        await this.closeLoading();
        const message =
          (e && e.response && e.response.data && e.response.data.result) ||
          (e && e.message) ||
          String(e);
        await this.showSnackBar({text: message, color: "error"});
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
    reloadPage() {
      this.$router.back();
    },
    async getReportNew(id, name, start_date, end_date) {
      if (
        !(
          parseInt(id) === 101 ||
          parseInt(id) === 100 ||
          parseInt(id) === 99 ||
          parseInt(id) === 98 ||
          parseInt(id) === 97 ||
          parseInt(id) === 96 ||
          parseInt(id) === 95 ||
          parseInt(id) === 93
        )
      ) {
        this.isFermi = false;
        return await axios.get(
          `https://nekohr.nekoapi.xyz/nekoapi/api/report/project/?project_id=${encodeURIComponent(
            id
          )}&token=2WLUPhj4GE9ePPuydGBV6ryA4gdaXpzBWV7B5ffnKfdaFhjKPL&user=fermi-guest&start_date=${encodeURIComponent(
            start_date
          )}&end_date=${encodeURIComponent(end_date)}`,
          {timeout: 120000}
        );
      } else {
        this.isFermi = true;
        return await axios.get(
          `https://nekohr.nekoapi.xyz/nekoapi/api/report/project/fermi-all/?token=2WLUPhj4GE9ePPuydGBV6ryA4gdaXpzBWV7B5ffnKfdaFhjKPL&user=fermi-guest&start_date=${encodeURIComponent(
            start_date
          )}&end_date=${encodeURIComponent(end_date)}`,
          {timeout: 120000}
        );
      }
    },
  },
};
</script>

<style scoped></style>
